module.exports = __webpack_public_path__ + "static/huawei-d5d5d99668fb221f2ddaadc9e4f6c8d0.png";